import type { Permission } from '@shared/types/global.types'
import { useAuthStore } from './useAuthStore'

export function usePermissions() {
  const { user, hasPermission, canPublish, canViewAnalytics } = useAuthStore()

  const isManager = user?.role === 'MANAGER' || user?.role === 'ADMIN'

  return {
    user,
    hasPermission: (permission: Permission) => hasPermission(permission),
    canPublish: () => canPublish(),
    canViewAnalytics: () => canViewAnalytics(),
    canManage: () => isManager,
    isAdmin: user?.role === 'ADMIN',
    isManager,
  }
}
